import { Box, BoxProps } from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

export const href = "https://www.linkedin.com/company/myareahub";

export type Linkedin_T = BoxProps;

export const Linkedin = (props: Linkedin_T) => {
  return (
    <Box as={FaLinkedin} aria-label="Linkedin" fill="linkedin" {...props} />
  );
};
